import React, { Component } from "react";

export default class ContactInfo extends Component {
	render() {
		return (
			<div className="section-padding" style={{paddingBottom:"0px"}}>
        <div className="max-width-container tiny-padding">
          <div className="white-background shadow">
            <div className="row">
              <div className="small-12 medium-7 background-image-fill" style={{backgroundImage:"url(/images/contact-square.jpg)" }}>
                <img className="full-width" src="/images/thumb.png"/>
              </div>
              <div className="small-12 medium-5 row">
                <div className="small-padding full-width" style={{margin:"auto"}}>
                  <h4 style={{margin:"0px",marginBottom:"10px"}}>{'Contact Us'}</h4>
                  <p style={{marginTop:'10px'}}>
                    <b>{'Email:'}</b><br /> <a href="mailto:info@pilatesavenue.com"><span className="mobile-teeny-font">{'info@pilatesavenue.com'}</span></a><br />
									</p>
									<p style={{marginTop:'10px'}}>
                    <b>{'Telephone:'}</b><br /> <span className="subheading">{'408.406.9311'}</span> <br/>
									</p>
									<p style={{marginTop:'10px'}}>
                    <b>{'Location:'}</b><br/>
                    <span className="subheading">{'Downtown Los Gatos, CA'}</span>
									</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/contactInfo/index.js